"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILD_BRANCHES = void 0;
exports.BUILD_BRANCHES = ['master', 'main', 'develop'];
//# sourceMappingURL=build.js.map